module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/whatsapp-3ebba13bfbc92748873abcbc846a7e41.png";